export enum SessionType {
  LIVE = 'Live',
  VOD = 'Vod',
  START_OVER = 'START_OVER',
  CATCH_UP = 'CATCH_UP',
}

export enum StreamFormat {
  DASH = 'mpegdash',
  HLS = 'applehttp',
}

export enum ContextType {
  PLAYBACK = 'PLAYBACK',
  START_OVER = 'START_OVER',
  CATCHUP = 'CATCHUP',
}

export interface PlayerSettings {
  presets: { [key: string]: any };
  hideUI?: boolean;
  isLive?: boolean;
}

export const SUBTITLE_OFF = 'off';
export const PLAYER_STORAGE_SUBTITLE_KEY = 'kaltura-player-js_textLanguage';
export const FULLSCREEN_ID = 'fullscreen';
export const broadpeakDefaultConfig = {
  analyticsAddress: '',
  broadpeakDomainNames: '*',
};

export const DRM_SUPPORTED = 'DRM_SUPPORTED';
export const CAPTION_SETTINGS = 'CAPTION_SETTINGS';
export const ADAPTER_DATA = {
  CODEC: {
    AVC: 'AVC',
  },
  QUALITY: {
    UHD: 'UHD',
    SD: 'SD',
    HD: 'HD',
  },
};
